
export const getCommitmentName = (context, createdBy, parameters) => {
  const { mutation } = parameters
  const { givenName, familyName } = mutation.investor

  const fullName = `${givenName} ${familyName}`

  return fullName
}
